var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.1875 11.6812C7.39583 11.3666 7.39583 10.9471 7.08333 10.7374L5 9.05957L2.29167 6.64771L19.2708 6.64771C19.6875 6.64771 20 6.33312 20 5.91366C20 5.59907 19.6875 5.28448 19.2708 5.28448L2.39583 5.28448L7.1875 1.1948C7.5 0.985075 7.5 0.565621 7.29167 0.25103C7.08333 -0.0635608 6.66667 -0.0635608 6.35417 0.146166L0.208334 5.49421C0.104168 5.59907 -2.53911e-07 5.8088 -2.63078e-07 6.01853C-2.72246e-07 6.22825 0.104168 6.43798 0.208334 6.54284L4.27083 10.2131L6.35417 11.8909C6.45833 12.1006 6.97917 11.9957 7.1875 11.6812Z","fill":"#00381F"}));
}

Arrow.defaultProps = {"width":"20","height":"12","viewBox":"0 0 20 12","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
